import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_URL } from '../../../../../services/config';
import { ListServerPaginationStateModel } from '../../../../../common/models';
import { AllocationViewProfile, AllocationViewProfileDto, AllocationViewProfileListSearchCriteria } from '../models';
import { AllocationViewProfilesEndpoint } from '../constants';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { ListQueryParam } from '../../../../../common/constants';

@Injectable({ providedIn: 'root' })
export class AllocationViewProfileListService {
  constructor(private http: WrapperHttpService) {}

  getProfiles(
    searchCriteria: AllocationViewProfileListSearchCriteria,
  ): Observable<ListServerPaginationStateModel<AllocationViewProfile>> {
    const queryString = getQueryStringFromObject(searchCriteria, [
      ListQueryParam.Page,
      ListQueryParam.Size,
      ListQueryParam.Sort,
    ]);
    const url = `${API_URL}${AllocationViewProfilesEndpoint.ViewProfilesAll}?${queryString}`;

    return this.http
      .withLoading()
      .get<AllocationViewProfileDto[]>(url)
      .pipe(
        map((profiles: AllocationViewProfileDto[]) => {
          const items = (profiles ?? []).map(this.mapProfileDisplayData);

          return {
            items,
            size: items.length,
            pageNumber: 0,
            numberOfElements: items.length,
            totalElements: items.length,
            totalPages: 1,
            loaded: true,
          };
        }),
      );
  }

  private mapProfileDisplayData(dto: AllocationViewProfileDto): AllocationViewProfile {
    return new AllocationViewProfile({
      ...dto,
      id: dto.profileId ?? dto.id,
    } as AllocationViewProfile);
  }
}
